// Function to convert newlines to <br> tags
export const convertNewLines = (text: string) => {
  return text.split("\n").map((each, i) => {
    return (
      <span key={i}>
        {each}
        <br />
      </span>
    );
  });
};

// export default ConvertNewLinesToBreak;
